import UsersService from '@/services/users.service';
export default {
    name: 'BeneficiaryForm',
    props: ['uuidAccount', 'selectedBeneficiary'],

    data() {
        return {
            beneficiary: {},
            isEdit: true,
            isLoading: false,
            productsOptions: [],
            otpActive: false,
            otpCodeValidate: undefined,
            uuid: '',
            interveners: [],
            account: {},
            updating: false,
            deleting: false
        };
    },

    async mounted() {
        this.isEdit = this.selectedBeneficiary === 'new' ? false : true;
        this.uuid = this.uuidAccount;
        await Promise.all([await this.loadAccountData(this.uuid)]);
        this.loadIntervenersData();

        this.$root.$on('dismiss', () => (this.otpActive = false));
        this.$root.$on('close-otp-modal', () => (this.otpActive = false));

        if (this.selectedBeneficiary !== 'new') {
            this.beneficiary = this.selectedBeneficiary;
        } else {
            await this.loadProducts();
            this.beneficiary = {
                given_name: '',
                family_name: '',
                key_product: null
            };
        }
    },

    beforeDestroy() {
        this.$root.$off('dismiss');
        this.$root.$off('close-otp-modal');
    },

    computed: {
        intervenersOTP() {
            const signatureTypesOTP = ['conjunta', 'mancomunada'];
            const intervenerRoleOTP = ['titular', 'nudo_propietario'];
            const signatureType = this.account.signature_type.toLowerCase();

            if (signatureTypesOTP.includes(signatureType)) {
                return this.interveners.filter(intervener => {
                    const intervenerRole = intervener.account_intervener_role[0].toLowerCase();

                    if (intervenerRoleOTP.includes(intervenerRole)) {
                        return intervener;
                    }
                });
            } else {
                const userIntervener = UsersService.getIntervenerFromLocalStore();
                return [userIntervener];
            }
        }
    },

    methods: {
        async loadAccountData(uuidAccount) {
            const response = await this.$accountService.getAccount(null, uuidAccount);
            this.account = response.data.account;
        },

        activateOTP(action) {
            let otpType = '';
            const params = {};

            switch (action) {
                case 'update':
                    this.updating = true;
                    this.deleting = false;
                    this.adding = false;
                    params.uuid_beneficiary = this.beneficiary.uuid;
                    otpType = 'VALIDATE_BENEFICIARY';
                    break;
                case 'delete':
                    this.updating = false;
                    this.deleting = true;
                    this.adding = false;
                    params.uuid_beneficiary = this.beneficiary.uuid;
                    params.uuid_account = this.uuidAccount;
                    otpType = 'DELETE_BENEFICIARY';
                    break;
                case 'add':
                    this.updating = false;
                    this.deleting = false;
                    this.adding = true;
                    params.uuid_account = this.uuidAccount;
                    otpType = 'ADD_BENEFICIARY';
                    break;
                default:
                    break;
            }

            const OTPData = {
                otp_type: otpType,
                params
            };
            this.$store.dispatch('setOTPData', OTPData);
            this.otpActive = true;
        },

        otpValidated(otpCodeValidate) {
            this.otpCodeValidate = otpCodeValidate;
            this.otpActive = false;
            if (this.updating) {
                return this.save();
            }

            if (this.deleting) {
                return this.remove();
            }

            if (this.adding) {
                return this.create();
            }
        },

        save() {
            this.isLoading = true;

            this.$accountService
                .updateAccountBeneficiary(
                    {},
                    this.beneficiary,
                    this.uuidAccount,
                    this.beneficiary.uuid
                )
                .then(() => {
                    this.isLoading = false;
                    this.$emit('update');
                })
                .catch(err => {
                    this.isLoading = false;

                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });

                    console.error(err);
                });
        },

        remove() {
            this.isLoading = true;
            this.$accountService
                .deleteAccountBeneficiary({}, this.uuidAccount, this.beneficiary.uuid)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('update');
                })
                .catch(err => {
                    this.isLoading = false;
                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });
                    console.error(err);
                });
        },

        create() {
            this.isLoading = true;
            const payload = {
                key_product: this.beneficiary.key_product,
                beneficiaries: [this.beneficiary]
            };
            this.$accountService
                .createBeneficiaries(this.uuidAccount, payload)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('update');
                })
                .catch(err => {
                    this.isLoading = false;

                    this.$bvToast.toast(`${err.message}`, {
                        title: 'Error',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 10000,
                        variant: 'danger'
                    });

                    console.error(err);
                });
        },

        cancel() {
            this.$emit('cancel');
        },

        setIntervenerRoles() {
            let intervenerMappedRoles = [];

            this.interveners.map(intervener => {
                intervenerMappedRoles = [];

                intervener.account_intervener_role.map(intervenerRole => {
                    this.rolesOptions.map(role => {
                        if (intervenerRole === role.key) {
                            intervenerMappedRoles.push(role);
                        }
                    });
                });

                intervener.account_intervener_role = intervenerMappedRoles;
            });
        },

        loadIntervenersData() {
            let intervenersList = [];

            // Get interveners
            this.$accountService
                .getAccountInterveners({}, this.uuidAccount)
                .then(response => {
                    response.data.accounts_intervener.map(intervener => {
                        //intervener.isMinor = isMinor(intervener);
                        intervener.account_intervener_role.map(role => {
                            if (role === 'TITULAR') {
                                intervener.isTitular = true;
                            }
                            return role;
                        });
                        intervenersList.push(intervener);
                    });

                    // Interveners array without beneficiaries
                    this.interveners = intervenersList;
                })
                .catch(error => console.error(error));
        },

        async loadProducts() {
            const responseProducts = await this.$productsService.getProducts({
                params: { $limit: 9999 }
            });
            const products = responseProducts.data.products;
            const responseOperations = await this.$accountService.getAccountOperations(
                { params: { $limit: 9999 } },
                this.uuidAccount
            );
            const accountOperations = responseOperations.data.related_operations;
            const ppProducts = [];
            if (
                accountOperations.find(
                    op =>
                        op.status !== 'CANCELLED' &&
                        (op.key_product === 'COBAS_MIXTO_GLOBAL' ||
                            op.key_target_product === 'COBAS_MIXTO_GLOBAL')
                )
            ) {
                ppProducts.push('COBAS_MIXTO_GLOBAL');
            }
            if (
                accountOperations.find(
                    op =>
                        op.status !== 'CANCELLED' &&
                        (op.key_product === 'COBAS_GLOBAL' ||
                            op.key_target_product === 'COBAS_GLOBAL')
                )
            ) {
                ppProducts.push('COBAS_GLOBAL');
            }
            this.productsOptions = products
                .filter(product => ppProducts.includes(product.key_name))
                .map(product => ({ value: product.key_name, text: product.name }));
        }
    }
};
